<template>
  <div id="EdicionMensaje_div">
    <div id="encabezado-" class="form-inline justify-content-between">
      <h5>{{tituloDeInformacion}}</h5>
    </div>
    <hr class="mt-2" />
    <div>
      
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Mensaje Proxima Firma</h6>
       
          <textarea class="form-control" type="text" placeholder="Ingrese el mensaje" rows="4" v-model="mensaje" id="mensaje" @input="(text) => (mensaje = mensaje.toUpperCase())" @keypress="esMensaje($event)" />
          
        </div>






      
    <!-- Botones guardar y cancelar -->
    <div class="d-flex row">
        <div  class="col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 pb-2 text-left">
            
             <button type="button" v-if="camposLlenos()" class="btn btn-success overwrapDeBotones mr-3"  @click="GuardarNuevoMensaje()"><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar</button>

             <button type="button" class="btn btn-danger overwrapDeBotones mr-3"  @click="Botoncancelar()"><i class="fas fa-window-close fa-lg"></i>&nbsp;&nbsp;Cancelar</button>
             
        </div>



       

        <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>
        
        
    </div>



  </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'

  import func from '../Comun/Funciones/comun.js'

  Vue.use(VueMask);

  export default {
    data() {
      
      return {
        togglePerspectivaRender: 1,
        enumeraciones,
        mensaje:null,  
        
      }

    },
    props: {
      esAlta:true,
      tituloDeInformacion: String,
      Mensajes:Object
    },

    // components: {
    //   C007TiposEstatusFirma: catalogos.SIVAC.C007TiposEstatusFirma
    // },

    /**
     * Método encargado de cargar valores predetermidados en caso de haberlos.
     */
    beforeMount() { 
      
      if(this.Mensajes.MensajeProximaFirma)
        this.mensaje = this.Mensajes.MensajeProximaFirma;
      
    },
    methods: {
     
       /** 
       * Metodo encargado de verificar que todos los campos requeridos estén llenos
       * @param {object} evento [evento emitido por el catalogo]
       */
      camposLlenos:function()
      {
        
        if (!this.mensaje || this.mensaje <= 0) 
          return false;
        
        return true;
      },
      
      
      /**
       * Función encargada de verificar que el campo proporcionado tenga un valor valido.  
       * @param {string/int/other} campo 
       */
      campoRequeridoEsValido: function(campo) {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      
      /**
       * Función encargada de llamar a API para guardar una Mensajes
       */
      GuardarNuevoMensaje:function()
      {

        bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por guardar un mensaje para la proxima firma del procesado, si decide continuar se guardara el nuevo mensaje. <br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Guardar'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {

                this.$emit('guardar2');
                
              }
            }
          });



      },



      Botoncancelar:function()
      {

       
     
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por cancelar el envio de un mensaje para la proxima firma.<br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {

                this.$emit("botoncancelar2");

                if(respuestaContinuar){      


                }

                
              }
            }
          });


               

      },

      esMensaje(datos){
        return func.esMensaje(datos)
      }
      



    },

    



    computed: {
     
    }
  }
</script>
<style scoped>
  .contenedor-puntero {
    background: #212529;
    border-radius:2px;
    padding: 10px;
    border:1px solid white;
    margin-bottom: 1.5em;
  }
  .form-control:disabled, .form-control[readonly]
  {
    background-color: #3D3C40 !important;
    pointer-events: none;
    color: #aaa;
  }
  ul { 
    list-style: none;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .contenedor-color-gris {        
        background-color: #9ea1a3;
        /*box-shadow: 0px 6px 20px 8px #161616;*/
        padding: 25px
    }

</style>



// WEBPACK FOOTER //
// src/components/SIVAC/Firmas/EdicionMensaje.vue